const browser = require('detect-browser');

export class OSUtils {

    public static IOS: string = "iOS";
    public static ANDROID: string = "Android OS";
    public static BLACKBERRY: string = "BlackBerry OS";
    public static WIN_MOBILE: string = "Windows Mobile";
    public static AMAZON_OS: string = "Amazon OS";
    public static WIN_3_11: string = "Windows 3.11";
    public static WIN_95: string = "Windows 95";
    public static WIN_98: string = "Windows 98";
    public static WIN_2000: string = "Windows 2000";
    public static WIN_XP: string = "Windows XP";
    public static WIN_SERVER_2003: string = "Windows Server 2003";
    public static WIN_VISTA: string = "Windows Vista";
    public static WIN_7: string = "Windows 7";
    public static WIN_8: string = "Windows 8";
    public static WIN_8_1: string = "Windows 8.1";
    public static WIN_10: string = "Windows 10";
    public static WIN_ME: string = "Windows ME";
    public static OPEN_BSD: string = "Open BSD";
    public static SUN_OS: string = "Sun OS";
    public static LINUX: string = "Linux";
    public static MAC_OS: string = "Mac OS";
    public static QNX: string = "QNX";
    public static BeOS: string = "BeOS";
    public static OS_2: string = "OS/2";
    public static SEARCH_BOT: string = "Search Bot";


    static isMobile(): boolean {
        return browser.os === OSUtils.IOS
            || browser.os === OSUtils.ANDROID
            || browser.os === OSUtils.BLACKBERRY
            || browser.os === OSUtils.WIN_MOBILE
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/utils/os.utils.ts